/* eslint-disable react/no-danger */
import React from 'react';
import dateTimeHelper from '../Helpers/datetimeHelper';
import CommentService from '../Services/CommentService';
import Loading from './loading.js';
import ErrorMessage from './ErrorMessage';
import FigmaButton from './FigmaButton';
import FigmaButtonRow from './FigmaButtonRow';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import '../Css/CommentsComponent.css';

class CommentComponent extends React.Component {
  static defaultProps = {
    entityTypeId: 6,
    entityId: 1,
    guidEntityId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      commentList: [],
      loading: true,
      showAddNewComment: false,
      newComment: '',
    };
    this.clickOnSaveNewCommentButton = this.clickOnSaveNewCommentButton.bind(this);
  }

  componentDidMount() {
    this.populateCommentListData();
  }

  async populateCommentListData() {
    this.setState({ loading: true });
    CommentService.GetCommentsByEntityTypeIdAndEntityId(
      this.props.entityTypeId,
      this.props.entityId,
      this.props.guidEntityId
    )
      .then((result) => {
        const convertedResult = CommentService.ConvertDBItem(result);
        this.setState({
          commentList: convertedResult,
          loading: false,
        });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: CCMP49');
        this.setState({ loading: false });
      });
  }

  async clickOnSaveNewCommentButton() {
    if (this.state.newComment === '') return;

    try {
      await CommentService.SaveComment(
        this.props.entityTypeId,
        this.props.entityId,
        this.state.newComment,
        this.props.guidEntityId
      );
      this.setState({
        showAddNewComment: false,
        newComment: '',
      });
      // Reload the list so the newly saved comment shows immediately.
      await this.populateCommentListData();
    } catch (error) {
      ErrorMessage.SetErrorMessage('Error! ErrorCode: CCMP50');
    }
  }

  renderAddButtonRow() {
    return (
      <FigmaButtonRow
        className='panel-corner-actions'
        buttons={[
          {
            iconName: this.state.showAddNewComment ? 'fa-solid fa-xmark' : 'fa-solid fa-plus-circle',
            type: ButtonTypeEnum.NormalIconOnly,
            color: this.state.showAddNewComment ? ButtonColorsEnum.Secondary : ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.setState({
                showAddNewComment: !this.state.showAddNewComment,
                newComment: '',
              }),
            tooltip: this.state.showAddNewComment ? 'Hide New Comment' : 'Add New Comment',
          },
        ]}
      />
    );
  }

  renderCommentList() {
    return (
      <div className='cmt-card'>
        <div className='cmt-card-head'>
          <span>{'Comments'}</span>
          {this.renderAddButtonRow()}
        </div>
        <div className='cmt-list'>
          {this.state.commentList.length === 0 && <div className='cmt-empty'>{'No comments yet'}</div>}
          {this.state.commentList.map((c, index) => (
            <div
              className='cmt-item'
              key={`com${index}`}
            >
              <p className='cmt-meta'>
                {c.CreatedByName !== undefined ? `Added by ${c.CreatedByName} on ` : ''}
                {dateTimeHelper.toYYYYsMMsDDsHHsMM(c.CreatedOn)}
              </p>
              <p
                className='cmt-body'
                dangerouslySetInnerHTML={{ __html: c.Message }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderAddNewComment() {
    if (!this.state.showAddNewComment) return null;
    return (
      <div className='cmt-add'>
        <textarea
          className='cmt-textarea'
          value={this.state.newComment}
          placeholder={'Type here your comment...'}
          onChange={(e) => this.setState({ newComment: e.target.value })}
        />
        <div className='cmt-add-actions'>
          <FigmaButton
            label={'Save comment'}
            iconName='fa-solid fa-paper-plane'
            iconPosition={IconPositionEnum.Left}
            color={ButtonColorsEnum.Primary}
            type={ButtonTypeEnum.NormalNormal}
            className='cmt-save-btn'
            disabled={this.state.newComment === ''}
            onClick={this.clickOnSaveNewCommentButton}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='comments-panel verticalScroll panel-max-height'>
        {this.renderAddNewComment()}
        <Loading loading={this.state.loading} />
        {!this.state.loading && this.renderCommentList()}
      </div>
    );
  }
}

export default CommentComponent;
